<template>
  <div class="menu-popup" :class="{'bottom': position === 'bottom', 'center': type === 'more', 'fixed': clientHeight <= 714}" v-if="itemData.length > 0">
    <div class="content">
      <div class="transparent-box"></div>
      <div class="menu-flex" :style="{width}" :class="{'flex-y': direction === 'Y', 'min-height': type === 'more'}">
        <!--订阅通知不显示-->
        <template v-for="(item, index) in itemData" >
        <div class="menu" :ref="`menu-${index}`" v-if="item.code !== 'noticeInfo'" :key="index">
          <!--更多特殊显示-->
          <div class="menu-item" style="flex: 0 0 90px; width: 90px" v-if="type === 'more'" @click="openMenu(item)">
            <i class="iconfont" :class="item.icon"></i>
            <p class="title">{{ item.name }}</p>
          </div>
          <div class="menu-item" v-else>
            <p class="title">{{ item.name }}</p>
            <ul class="menu-item-child" :style="{height}" :class="index > 2 ? 'minH' : ''" v-if="item.list && item.list.length > 0">
              <li v-for="(itemChild, k) in item.list" :key="'child' + k">
                <a :href="getToUrl(itemChild)" :class="{greyColor: !getMenuUrl(itemChild)}" @click="openMenu(itemChild, $event)">{{ itemChild.name }}</a>
<!--                <a href="#" :class="{greyColor: !getMenuUrl(itemChild)}" @click="openMenu(itemChild, $event)">{{ itemChild.name }}</a>-->
              </li>
            </ul>
          </div>
        </div>
        </template>

        <div class="logout" v-if="showLogout">
          <p @click="logout">
            <i class="iconfont icon-userback" ></i>
            <span>{{ $t('MENUSLIDE.tui-chu-deng-lu') }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import login from '../../data/login'
  import { ElMessageBox } from 'element-plus/es/components/message-box'

  import { menueEentMap } from './menuEvent'

  export default {
    name: 'menuPopup',
    props: {
      position: {
        type: String,
        default: 'top'
      },
      // 布局方向
      direction: {
        type: String,
        default: 'X'
      },
      height: {
        type: String,
        default: '252px'
      },
      width: {
        type: String,
        default: 'auto'
      },
      item: {
        type: Object,
        default: () => { }
      },
      type: {
        type: [String, Number],
        default: ''
      },
      itemData: {
        type: Array,
        default: () => []
      },
      showLogout: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        // 左侧菜单栏需要的高度至少是714px < 714 固定定位居中， > 714 绝对定位 相当于节点位置定位
        clientHeight: document.body.clientHeight
      }
    },
    mounted() {
      const that = this
      window.onresize = () => {
        return (() => {
          that.clientHeight = document.body.clientHeight
        })()
      }
    },
    methods: {
      /**
       * 跳转
       */
      openMenu(item, event) {
        // 埋点监控
        this.normalizeEventPoint(item)

        this.$emit('openMenu', item, this.item, event)
      },

      /**
       * 退出登录
       */
      logout() {
        ElMessageBox.confirm(
            `退出登录`,
            '提示',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              type: 'warning',
            })
            .then(() => {
              login.out()
            })
            .catch(() => {
            })
      },

      /**
       * 获取跳转url
       * @param item
       * @returns {null}
       */
      getToUrl(item) {
        let url = this.getMenuUrl(item)
        if (!url || (item && item.trans && item.trans.code === 'QUESTIONNAIRE')) {
          // this.$Message.info('该菜单地址未定义');
          return null
        }
        if (item.appendix) {
          url += '?' + item.appendix
        }
        if (item.trans && item.trans.code === 'TRE_PARTNER_ACCOUNT') {
          url = '/v/vcommon/companyAccount/index'
        }
        if (!url.startsWith('/')) {
          url = '/' + url
        }
        if (url.startsWith('/vexpense')) {
            url = url.replace('vexpense', 'expense')
        }
        if (!url.startsWith('/v/')) {
          url = '/v' + url
        }

        if (url && url.includes('/vcommon/jsp')) {
          url = url.replace('/vcommon/jsp', '')
        }

        return url
      },

      /**
       * 埋点监控 a标签进入url
       * @param item
       */
      normalizeEventPoint(item) {
        if (item.id && menueEentMap[item.id]) {
          window.$ztDataAction.push({
            action: 'aplus.record',
            arguments: [menueEentMap[item.id], 'CLK']
          });
        }
      },

      getMenuUrl(menu) {
        return menu.trans ? menu.trans.def : menu.def || menu.url
      },

      goPage(item) {
        if (item.code === 'order') {
          window.$jump.to('/votapub/common/orderList')
        } else {
          window.$jump.to('/notify/message/loadUnDoTask.html')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .menu-popup:hover {
    display: block;
  }
  .menu-popup {
    position: absolute;
    display: none;
    top: 0;
    transform: translateY(-40%);
    left: 68px;
    z-index: 9;
    padding: 12px;
    max-width: 608px;
    min-width: 184px;
    min-height: 222px;
    .content {
      display: flex;
    }
    .transparent-box {
      /*width: 20px;*/
      flex: 0 0 20px;
      height: 222px;
      background-color: transparent;
    }
    .menu-flex {
      flex-shrink: 0;
      padding: 12px;
      border-radius: 8px;
      box-sizing: border-box;
      max-width: 564px;
      min-width: 184px;
      /*width: 184px;*/
      /*width: 588px;*/
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      background-color: #495060;
    }
    .min-height {
      height: 100px;
      .menu {
        margin: 0;
      }
      i {
        font-size: 24px;
        color: #fff;
      }
      .menu-item {
        flex: 0 0 184px;
        height: 76px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
    .flex-y {
      width: 200px;
      flex-direction: column;
    }
    .menu {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      .title {
        font-size: 14px;
        color: #fff;
        font-weight: 500;
      }
      .menu-item {
        padding: 0 6px;
        width: 180px;
        font-size: 12px;
        color: rgba(255, 255, 255, .6);
        box-sizing: border-box;
        a {
          text-underline: none;
        }
        .menu-item-child {
          margin-top: 10px;
          padding: 10px;
          height: 252px;
          /*min-height: 222px;*/
          /*max-height: 292px;*/
          background-color: #424857;
          box-sizing: border-box;
          border-radius: 8px;
          overflow-x: auto;
          overflow-y: visible;
          scrollbar-width: none;
          -ms-overflow-style: none;
        }
        .minH {
          height: 120px!important;
        }
        .menu-item-child::-webkit-scrollbar {
          display: none;
        }
        ul {
          display: flex;
          flex-direction: column;
          li {
            position: relative;
            padding-left: 6px;
            display: inline-flex;
            width: 100%;
            height: 28px;
            flex-shrink: 0;
            align-items: center;
            cursor: pointer;
            a {
              color: rgba(255, 255, 255, .6);
              text-decoration: none;
            }
            .greyColor {
              color: #65676c;
              cursor: none;
            }
          }
          li:hover .greyColor {
            text-decoration: none!important;
          }
          li:hover a {
            text-decoration: underline;
            text-underline-offset: 3px;
          }
          li:before {
            position: absolute;
            content: '';
            left: -2px;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background-color: #fff;
          }
        }
      }
    }
    .menu:nth-child(3n+3)  {
      padding-right: 0;
    }

    .logout {
      margin: 16px 0 0 8px;
      padding-top: 12px;
      width: 100%;
      border-top: 1px solid rgba(255, 255, 255, .15);
      p {
        display: inline-flex;
        align-items: center;
      }
      i {
        margin-right: 5px;
        font-size: 20px;
      }
      span {
        font-size: 14px;
      }
    }
  }
 .menu-popup.center {
    top: 0px;
    transform: translateY(-10px);
  }
  .menu-popup.bottom {
    top: auto;
    bottom: 0;
    transform: translateY(12px);
  }

  @media (max-height: 716px) {
    .menu-popup {
      position: fixed;
      display: none;
      top: 50%!important;
      transform: translateY(-50%)!important;
      left: 88px;
      z-index: 9;
      padding: 12px;
      max-width: 608px;
      min-width: 184px;
      min-height: 222px;
    }
    .menu-popup.bottom {
      position: absolute;
      top: auto!important;
      bottom: 0!important;
      left: 72px!important;
      transform: translateY(12px)!important;
    }
  }
</style>
